import { Navigate } from "react-router-dom";
import { hasActiveAuthSession, hasPendingVerification } from "../../utils/authSession";
import { isBasicPlanUser } from "../../utils/basicPlanAccess";
import { isAppSetupWizardActive } from "../../utils/appSetupWizardStorage";

export default function GuestOnlyRoute({ children }) {
    if (isAppSetupWizardActive()) {
        return children;
    }

    if (hasActiveAuthSession() && !hasPendingVerification()) {
        return <Navigate to={isBasicPlanUser() ? "/payment" : "/contact"} replace />;
    }
    return children;
}
